export const RightShipInspectionRoutes = {
    GetRSInspectionNonConformity: "RightShipInspection/GetRSInspectionNonConformity",
    GetRSInspectionOutcome: "RightShipInspection/Outcome",
    GetInsights: "RightShipInspection/GetInsights",
    GetInspectionThumbnailZipFile: "RightShipInspection/GetInspectionThumbnailZipFile",
    GetRightShipInspectionDocumentLinks: "RightShipInspection/GetRightShipInspectionDocumentLinks",
    GetFindingAllDocumentsCount: "RightShipInspection/GetFindingAllDocumentsCount",
    GetRightshipInspectionFleetBenchMarkingChart: "RightShipInspection/GetRightshipInspectionFleetBenchMarkingChart",
    GetRightShipInspectionFindingsImages: "RightShipInspection/GetRightShipInspectionFindingsImages",
    UltrasonicReport: "RightShipInspection/UltrasonicReport"
};